@for (item of filterOptions | async; track item) {
  <div>
    <div class="form-group">
      @if (item.text) {
        <label>{{item.text | translate}}</label>
      }
      <input type="text" class="form-control" [placeholder]="'0 '+ suffix" [suffix]="suffix" mask="separator.2"
        thousandSeparator="." (change)="onChange(filter)" [(ngModel)]="item.value"
        [ngModelOptions]="{standalone: true}" />
      </div>
    </div>
  }
